//
// Shop: Search PRO plugin
//

( function($, waTheme) {

    $(document).ready(function () {
        $(".b-search-pro.b-search-pro--hidden").removeClass("b-search-pro--hidden");
    });

})(jQuery, window.waTheme);
